import React, { useState } from 'react';
import './Modal.css';

interface PasswordDisplayModalProps {
  isOpen: boolean;
  onClose: () => void;
  username: string;
  password: string;
  userType?: string;
  coordinates?: {
    latitude: number;
    longitude: number;
  };
  radiusZips?: {
    '10': number;
    '20': number;
    '30': number;
  };
}

const PasswordDisplayModal: React.FC<PasswordDisplayModalProps> = ({
  isOpen,
  onClose,
  username,
  password,
  userType = 'user',
  coordinates,
  radiusZips,
}) => {
  const [copied, setCopied] = useState(false);

  const handleCopy = () => {
    navigator.clipboard.writeText(password);
    setCopied(true);
    setTimeout(() => setCopied(false), 2000);
  };

  const handleClose = () => {
    setCopied(false);
    onClose();
  };

  if (!isOpen) return null;

  return (
    <div className="modal-overlay" onClick={handleClose}>
      <div className="modal-content modal-small" onClick={(e) => e.stopPropagation()}>
        <div className="modal-header">
          <h2>
            <span className="material-icons">check_circle</span>
            {userType === 'dealer' ? 'Dealer' : 'User'} Created Successfully
          </h2>
          <button className="modal-close" onClick={handleClose}>
            <span className="material-icons">close</span>
          </button>
        </div>

        <div className="modal-body">
          <div className="form-success-banner">
            <span className="material-icons">info</span>
            <div>
              <strong>Username:</strong> {username}
            </div>
          </div>

          <div className="password-display">
            <div className="password-display-header">
              <span className="material-icons">key</span>
              <strong>Temporary Password</strong>
            </div>

            <div className="password-value">
              <span className="password-text">{password}</span>
              <button
                className={`copy-button ${copied ? 'copied' : ''}`}
                onClick={handleCopy}
              >
                <span className="material-icons">{copied ? 'check' : 'content_copy'}</span>
                {copied ? 'Copied!' : 'Copy'}
              </button>
            </div>

            <div className="password-warning">
              <span className="material-icons">warning</span>
              <p>
                <strong>Important:</strong> This password will only be shown once. Please save it
                securely before closing this window.
              </p>
            </div>
          </div>

          {coordinates && (
            <div className="info-display">
              <h4 style={{ marginTop: 0, marginBottom: '0.75rem' }}>Location Information</h4>
              <div className="info-row">
                <span className="info-label">Latitude:</span>
                <span className="info-value">{coordinates.latitude.toFixed(6)}</span>
              </div>
              <div className="info-row">
                <span className="info-label">Longitude:</span>
                <span className="info-value">{coordinates.longitude.toFixed(6)}</span>
              </div>
            </div>
          )}

          {radiusZips && (
            <div className="info-display" style={{ marginTop: '1rem' }}>
              <h4 style={{ marginTop: 0, marginBottom: '0.75rem' }}>Radius ZIP Codes</h4>
              <div className="info-row">
                <span className="info-label">10-mile radius:</span>
                <span className="info-value">{radiusZips['10']} ZIP codes</span>
              </div>
              <div className="info-row">
                <span className="info-label">20-mile radius:</span>
                <span className="info-value">{radiusZips['20']} ZIP codes</span>
              </div>
              <div className="info-row">
                <span className="info-label">30-mile radius:</span>
                <span className="info-value">{radiusZips['30']} ZIP codes</span>
              </div>
            </div>
          )}
        </div>

        <div className="modal-footer">
          <button className="btn-primary" onClick={handleClose}>
            <span className="material-icons">done</span>
            Done
          </button>
        </div>
      </div>
    </div>
  );
};

export default PasswordDisplayModal;
